import React from 'react';
import SwiperComp from './Swiper';

export default function Reviews() {
  return (
    <div className="flex flex-col">
      <div className="flex justify-between items-center mb-5">
        <p className="md:text-2xl text-base font-medium text-[#222222]">Review Dari Pengunjung</p>
        <button className="bg-button md:text-base text-xs text-primary font-medium px-11 py-4 rounded">
          Beri Review
        </button>
      </div>
      <div className="w-full">
        <SwiperComp />
      </div>

      <div className="flex flex-col justify-center items-center mb-[8%] mt-[3%]">
        <button className="bg-[#F8F8F8] font-medium md:text-base text-xs px-6 py-4 text-[#C5C5C5] text-center">
          Lihat Semua Review
        </button>
      </div>
    </div>
  );
}
